import * as React from 'react';
import * as styles from './styles.css';

export interface IStripProps {
  children: React.ReactChild | React.ReactChild[];
  stripRef?: React.RefObject<HTMLDivElement>;
  onSwipe?(): void;
}

export function Strip({ children, stripRef, onSwipe }: IStripProps) {
  return (
    <div onScroll={onSwipe} className={styles['container']}>
      <div className={styles['line']} ref={stripRef}>
        {children}
      </div>
    </div>
  );
}
